import React, { useEffect } from 'react';
import { RuleType } from '@loyalty/shared-common/rule-api-client';
import { BurningRulesTable } from '../../libs/burning-rules/BurningRulesTable';
import { QlfMasterDetailContainer } from '../../libs/shared/layout/QlfMasterDetailContainer';
import { useCustomKeys } from '../../libs/custom-keys/CustomKeysContext';
import { useRewards } from '../../libs/rewards/RewardsContext';
import { useRules } from '../../libs/rules/RulesContext';

export function BurningRulesIndexPage(): React.ReactElement {
  const { burningRules, fetchRules } = useRules();
  const { rewards, fetchRewards } = useRewards();
  const { customKeys, getCustomKeys } = useCustomKeys();

  useEffect(() => {
    if (!rewards) {
      fetchRewards();
    }
    if (!burningRules) {
      fetchRules(RuleType.BURN);
    }
    if (!customKeys) {
      getCustomKeys();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <QlfMasterDetailContainer>
      <BurningRulesTable />
    </QlfMasterDetailContainer>
  );
}
